import upperFirst from 'lodash/upperFirst';
import { memo } from 'react';

import type { Appointment } from '@wecasa/common/src/types/commons';
import { getAppointmentsSortedByDayDeprecated } from '@wecasa/common/src/utils/appointment';
import { FORMATS, formatDateDeprecated } from '@wecasa/common/src/utils/date';

import { translate } from '@wecasa/i18n';

import Text from '@wecasa/web-ui/src/components/base-text/variants/text';

import { Day, DaysList, Slots } from '../../../common/common';
import Slot from '../../../common/sections/appointments/slot';

const t = translate('basket');

type AppointmentDetailsProps = {
  appointment: Appointment;
};

const AppointmentDetails = ({ appointment: { primary, secondary } }: AppointmentDetailsProps) =>
  secondary.length === 0 ? (
    <Text>{t('.secondary_appointment.zero')}</Text>
  ) : (
    <DaysList>
      {getAppointmentsSortedByDayDeprecated(primary, secondary).map(({ day, slots }) => (
        <Day key={day.toISOString()}>
          <Text.MDBold>{upperFirst(formatDateDeprecated(day, FORMATS.DATE.WEEKDAY_DAY_MONTH))}</Text.MDBold>
          <Slots>
            {slots.map(({ text, isPrimary, label }) => (
              <Slot key={text} text={text} isPrimary={isPrimary} label={label} />
            ))}
          </Slots>
        </Day>
      ))}
    </DaysList>
  );

export default memo(AppointmentDetails);
